import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class TransactionRequestLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public transactionRequestId: number = 0;

    @Attributes.Date()
    public requestedDate: Date = new Date();

    @Attributes.Float()
    public requestedAmount: number = 0;

    @Attributes.Float()
    public allocatedAmount: number = 0;

    // Client only properties / methods
}